// MATERIAL UI
import { Skeleton, Stack, Typography } from "@mui/material";

// REDUX
import api from "src/store/features/api";

// STYLES
import { BORDER_LIGHT, Card, NAVY, TEXT_MUTED, TEXT_SECONDARY } from "./styles";

const Row = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between">
    <Typography sx={{ fontSize: 13, color: TEXT_SECONDARY }}>{label}</Typography>
    <Typography sx={{ fontSize: 13, fontWeight: 500, color: NAVY }}>{value}</Typography>
  </Stack>
);

const TaxSettingsSummaryCard = ({ onOpen }: { onOpen: () => void }) => {
  const accountQuery = api.useGetTaxAccountQuery();

  return (
    <Card
      onClick={onOpen}
      sx={{
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 1.75,
        height: "100%",
        cursor: "pointer",
        "&:hover": { borderColor: TEXT_MUTED },
      }}>
      <Typography sx={{ fontSize: 17, fontWeight: 600, color: NAVY, lineHeight: 1.3 }}>
        Tax settings
      </Typography>
      <Typography sx={{ fontSize: 14, color: TEXT_SECONDARY, lineHeight: 1.55 }}>
        Choose how disposals are matched against your holdings and how forms are delivered.
      </Typography>
      <Stack spacing={1.25} sx={{ mt: "auto", pt: 1.75, borderTop: `1px solid ${BORDER_LIGHT}` }}>
        <Row
          label="Disposition method"
          value={
            accountQuery.isLoading ? (
              <Skeleton width={48} />
            ) : (
              (accountQuery.data?.disposition_method ?? "—")
            )
          }
        />
        <Row label="Form delivery" value="Paperless" />
      </Stack>
    </Card>
  );
};

export default TaxSettingsSummaryCard;
